import { makeStyles, Theme } from '@surveycake/rc';
import { SubjectIndent } from '@surveycake/logic-engine';

const typeStyleMap = {
  default: (singleSubjectPerPage: boolean, indent: SubjectIndent) => [
    !singleSubjectPerPage &&
      indent === 1 &&
      `
			width: 96%;
			margin-left: 4%;
		`
  ],
  QUOTE: (
    theme: Theme,
    singleSubjectPerPage: boolean,
    indent: SubjectIndent
  ) => {
    if (singleSubjectPerPage) {
      return [
        `
					width: 100%;
					align-self: center;
				`
      ];
    }

    const quoteMarginLeft = 16;

    return [
      `
				width: auto;
				border-radius: 10px;
				border: 2px dashed ${theme.survey.color.gray};
				margin: 0 ${quoteMarginLeft}px 30px;
				padding-top: 30px;
			`,
      indent === 1 &&
        `
				width: calc(96% - ${quoteMarginLeft * 2}px);
				margin-left: calc(4% + ${quoteMarginLeft}px);
			`
    ];
  },
  STATEMENT: (theme: Theme, singleSubjectPerPage: boolean) => [
    singleSubjectPerPage &&
      `
			width: 100%;
			align-self: center;
			text-align: center;

			&::before {
				display: inline-block;
				content: '';
				width: 24px;
				height: 5px;
				background-color: ${theme.color.primary.default};
				margin-bottom: 3px;
			}
		`,
    !singleSubjectPerPage &&
      `
			border-left: 5px solid ${theme.color.primary.default};
			margin-bottom: 30px;
			padding-bottom: 0;
			text-align: left;
		`
  ]
};

export const useStyles = makeStyles([
  [
    'subject',
    (theme, [indent, type, singleSubjectPerPage, hasTimer]) => {
      let typeStyle;

      if (type === 'QUOTE') {
        typeStyle = typeStyleMap.QUOTE(theme, singleSubjectPerPage, indent);
      } else if (type === 'STATEMENT') {
        typeStyle = typeStyleMap.STATEMENT(theme, singleSubjectPerPage);
      } else {
        typeStyle = typeStyleMap.default(singleSubjectPerPage, indent);
      }

      return [
        `
				position: relative;
				width: 100%;
				height: auto;
				margin: 0 auto;
				padding: 0 16px 30px;
				background-color: transparent;
				overflow: hidden;
				box-sizing: border-box;
			`,
        hasTimer &&
          `
				min-height: 170px;
			`,
        ...typeStyle
      ];
    }
  ]
]);
